import React, { useState, useEffect } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import { useNavigate } from 'react-router-dom';

export default function Dashboard() {

  const navigate = useNavigate();

  const [leads, setLeads] = useState('');

  const bookingList = () => {
    const requestOptions = {
        method: "GET",
        redirect: "follow"
    };

    fetch("https://api.padampura.com/Reservation_AllList", requestOptions)
      .then((response) => response.json())
        .then((result) => {
            if (result.status === true) {
                // console.log(result)
                setLeads(result.data.length)
            }
        })
        .catch((error) => console.error(error));
}  

useEffect(()=>{
  bookingList();
   const intervalId = setInterval(bookingList, 2 * 60 * 1000);
    return () => clearInterval(intervalId);
},[])

  return (
    <>
      <div className='container-fluid p-0'>
        <div className='row g-0'>
          <div className='col-2 side'>
            <Sidebar />
          </div>
          <div className='col-10 side2'>
            <Header />
            <div className='scroll-box'>
              <div className='container mt-3'>
                <div className='pb-2 d-flex justify-content-between'>
                  <div className='text-start' style={{ fontFamily: "Poppins", fontSize: "22px", fontWeight: 500, color: '#566573' }}>Dashboard</div>
                </div>
                <div className='row mb-3'>
                  <div className='col-lg-4 col-md-6 col-sm-12 mb-3'>
                    <div className='card p-4 border-0' onClick={() => navigate('/Booking')} style={{ width: "100%", backgroundImage: 'linear-gradient(to right, #223655, #006690, #00999f, #00c877, #a8eb12)', cursor: "pointer" }}>
                      <div style={{ fontFamily: "Poppins", fontSize: "18px", fontWeight: 500, color: '#fff' }}>Leads Request</div>
                      <div style={{ fontFamily: "Poppins", fontSize: "14px", fontWeight: 500, color: '#fff' }}>{leads}</div>
                    </div>
                  </div>
                  <div className='col-lg-4 col-md-6 col-sm-12 mb-3'>
                    <div className='card p-4 border-0' style={{ width: '100%', backgroundColor: "#EBDEF0" }}>
                      <div style={{ fontFamily: "Poppins", fontSize: "18px", fontWeight: 500, color: '#000' }}>Today Leads</div>
                      <div style={{ fontFamily: "Poppins", fontSize: "14px", fontWeight: 500, color: '#000' }}>10</div>
                    </div>
                  </div>
                  <div className='col-lg-4 col-md-6 col-sm-12 mb-3'>
                    <div className='card p-4 border-0' style={{ width: '100%', backgroundColor: "#D5D8DC" }}>
                      <div style={{ fontFamily: "Poppins", fontSize: "18px", fontWeight: 500, color: '#000' }}>Guru</div>
                      <div style={{ fontFamily: "Poppins", fontSize: "14px", fontWeight: 500, color: '#000' }}>10</div>
                    </div>
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-lg-4 col-md-6 col-sm-12 mb-3'>
                    <div className='card p-4 border-0' style={{ width: "100%", backgroundColor: '#A3E4D7' }}>
                      <div style={{ fontFamily: "Poppins", fontSize: "18px", fontWeight: 500, color: '#000' }}>Today Collection</div>
                      <div style={{ fontFamily: "Poppins", fontSize: "14px", fontWeight: 500, color: '#000' }}>9</div>
                    </div>
                  </div>
                  <div className='col-lg-4 col-md-6 col-sm-12 mb-3'>
                    <div className='card p-4 border-0' style={{ width: '100%', backgroundColor: "#F2D7D5" }}>
                      <div style={{ fontFamily: "Poppins", fontSize: "18px", fontWeight: 500, color: '#000' }}>Total Booking</div>
                      <div style={{ fontFamily: "Poppins", fontSize: "14px", fontWeight: 500, color: '#000' }}>10</div>
                    </div>
                  </div>
                  <div className='col-lg-4 col-md-6 col-sm-12 mb-3'>
                    <div className='card p-4 border-0' style={{ width: '100%', backgroundColor: "#FCF3CF " }}>
                      <div style={{ fontFamily: "Poppins", fontSize: "18px", fontWeight: 500, color: '#000' }}>Events</div>
                      <div style={{ fontFamily: "Poppins", fontSize: "14px", fontWeight: 500, color: '#000' }}>10</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
